<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Edit Event</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/admin/events" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
            <form @submit.prevent="updateEvent" v-if="event">
                <div class="row justify-content-md-center">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-md-4">
                                <fg-input type="text"
                                          v-model="event.title"
                                          label="Event Title"
                                          placeholder="Enter Event Title"
                                          v-validate="rules.title"
                                          data-vv-name="title"
                                          cus-name="title"
                                          :has-errors="errors"
                                          :is-fields="fields">
                                </fg-input>
                            </div>
                            <div class="col-md-4" v-if="type.length">
                                <fg-select
                                        v-model="event.type"
                                        label="Type"
                                        v-validate="rules.type"
                                        data-vv-name="type"
                                        cus-name="type"
                                        :has-errors="errors"
                                        :is-fields="fields"
                                        :list="type"
                                        selectedKey="id"
                                        >
                                </fg-select>
                            </div>
                            <div class="col-md-4">
                                <fg-input type="text"
                                          v-model="event.tags"
                                          label="Event Tags"
                                          placeholder="Enter Comma separated Tags"
                                          v-validate="rules.tags"
                                          data-vv-name="tags"
                                          cus-name="tags"
                                          :has-errors="errors"
                                          :is-fields="fields">
                                </fg-input>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4">
                                <label>Start Date</label>
                                <datetime v-model="startDate"
                                          input-class="form-control"
                                          placeholder="Choose a Date"
                                          type="datetime"
                                          :min-datetime="today"
                                          input-format="DD-MM-YYYY HH:mm"
                                          auto-continue>

                                </datetime>
                            </div>
                            <div class="col-4">
                                <label>End Date</label>
                                <datetime v-model="endDate"
                                          input-class="form-control"
                                          placeholder="Choose a Date"
                                          type="datetime"
                                          input-format="DD-MM-YYYY HH:mm"
                                          auto-continue>

                                </datetime>
                            </div>
                            <div class="col-4">
                                <fg-input type="number"
                                          v-model="event.duration"
                                          label="Event Duration"
                                          placeholder="Enter Event Duration"
                                          v-validate="rules.duration"
                                          data-vv-name="duration"
                                          cus-name="duration"
                                          :has-errors="errors"
                                          :is-fields="fields">
                                </fg-input>
                            </div>
                            <div class="col-md-12">
                                <fg-text-area
                                        rows="5"
                                        v-model="event.description"
                                        label="Event Description"
                                        placeholder="Enter Event Description"
                                        v-validate="rules.description"
                                        data-vv-name="description"
                                        cus-name="description"
                                        :has-errors="errors"
                                        :is-fields="fields">
                                </fg-text-area>
                            </div>
                            <div class="col-md-12">
                                <fg-text-area
                                        rows="5"
                                        v-model="event.longDescription"
                                        label="Long Description"
                                        placeholder="Enter Event Long Description"
                                        v-validate="rules.longDescription"
                                        data-vv-name="Long Description"
                                        cus-name="Long Description"
                                        :has-errors="errors"
                                        :is-fields="fields">
                                </fg-text-area>
                            </div>
                            <div class="col-md-12">
                                <fg-image type="file"
                                          v-on:file="updateValue"
                                          v-model="event.img_url"
                                          label="Event Image"
                                          placeholder="Enter Comma separated Tags"
                                          v-validate="rules.img_url"
                                          data-vv-name="event image"
                                          cus-name="event image"
                                          :has-errors="errors"
                                          :is-fields="fields">
                                </fg-image>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <fg-text-area
                                        rows="5"
                                        v-model="event.authBannerText"
                                        label="Auth Banner"
                                        placeholder="Enter Auth Banner Text"
                                        v-validate="rules.authBanner"
                                        data-vv-name="authBanner"
                                        cus-name="authBanner"
                                        :has-errors="errors"
                                        :is-fields="fields">
                                </fg-text-area>
                            </div>
                            <div class="col-12">
                                <fg-text-area
                                        rows="5"
                                        v-model="event.unAuthBannerText"
                                        label="Unauth Banner"
                                        placeholder="Enter Unauth Banner Text"
                                        v-validate="rules.unAuthBanner"
                                        data-vv-name="unAuthBanner"
                                        cus-name="unAuthBanner"
                                        :has-errors="errors"
                                        :is-fields="fields">
                                </fg-text-area>
                            </div>
                        </div>
                        <div class="row">
                          <div class="col-4">
                                <fg-input type="text"
                                          v-model="event.jw_stream_title"
                                          label="Video Code"
                                          placeholder="Enter Video Code"
                                      >
                                </fg-input>
                          </div>
                            <div v-if="event.type == '1' || !event.type" class="col-4">
                                <fg-input type="text"
                                          v-model="event.jw_rtmp_url"
                                          label="JW RTMP URL"
                                          placeholder="Enter JW RTMP URL">
                                          <!--v-validate="rules.jw_rtmp_url"-->
                                          <!--data-vv-name="jw_rtmp_url"-->
                                          <!--cus-name="jw_rtmp_url"-->
                                          <!--:has-errors="errors"-->
                                          <!--:is-fields="fields">-->
                                </fg-input>
                            </div>
                            <div class="col-4">
                                <fg-input type="text"
                                          v-model="event.chatroll_event_name"
                                          label="Chat Roll Event Name"
                                          placeholder="Enter Chat Roll Event Name"
                                          v-validate="rules.chatroll_event_name"
                                          data-vv-name="chatroll_event_name"
                                          cus-name="chatroll_event_name"
                                          :has-errors="errors"
                                          :is-fields="fields">
                                </fg-input>
                            </div>
                          <div class="col-12" v-if="experts.length">
                            <multiselect
                              v-model="event.csvExpertsIds"
                              placeholder="Select Expert(s)"
                              :multiple="true"
                              :options="experts.map(type => type.expertId)"
                              :custom-label="opt => experts.find(x => x.expertId == opt).name"
                              required>
                              >
                            </multiselect>
                          </div>
                          <div class="col-4">
                            <fg-input type="text"
                                      v-model="event.toneLive"
                                      label="Has Playlist Archive"
                                      placeholder="0 or 1, 1 if true"
                                      :is-fields="fields">
                            </fg-input>
                          </div>
                          <div class="col-4">
                            <fg-input type="number"
                                      v-model="event.eventSwitchTime"
                                      label="Switch Time (Minutes)"
                                      placeholder="Enter Switch Time (Optional)"
                            >
                            </fg-input>
                          </div>
                          <div class="col-4" v-if="corporations.length">
                            <fg-select
                              v-model="event.corporationId"
                              label="Corporation (Optional)"
                              :list="corporations"
                              selectedKey="corporationId"
                            >
                            </fg-select>
                          </div>
                          <div class="col-4" v-if="eventType.length">
                            <fg-select
                              v-model="event.isPrivate"
                              label="Event Visibility"
                              v-validate="rules.isPrivate"
                              data-vv-name="Event Visibility"
                              cus-name="Event Visibility"
                              :has-errors="errors"
                              :is-fields="fields"
                              :list="eventType"
                              selectedKey="id"
                            >
                            </fg-select>
                          </div>
                          <div class="col-4">
                            <fg-input type="text"
                                      v-model="event.corporateEventArchive"
                                      label="Enable Corporate Archive"
                                      placeholder="0 or 1, 1 if true"
                                      :is-fields="fields">
                            </fg-input>
                          </div>
                            <div class="col-4" v-if="status.length">
                                <fg-select
                                        v-model="event.status"
                                        label="Status"
                                        v-validate="rules.status"
                                        data-vv-name="status"
                                        cus-name="status"
                                        :has-errors="errors"
                                        :is-fields="fields"
                                        :list="status"
                                        selectedKey="id"
                                        >
                                </fg-select>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 text-center">
                        <button type="submit" :disabled="errors.any() || (!event.csvExpertsIds || event.csvExpertsIds.length === 0)" class="btn btn-primary btn-fill btn-block">
                            Update Event
                        </button>
                    </div>
                </div>
                <div class="clearfix"></div>
            </form>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { imageHelpers } from '../../../../helpers/lambda'
    import moment from 'moment'
    export default {
        name: 'EditEvent',
        created (){
        this.$store.dispatch('GETSELECTEDEVENT', this.$route.params.id).then(() =>{
            this.event = this.selectedEvent;
            this.startDate = new Date(this.event.start_date).toISOString();
            this.endDate = new Date(this.event.end_date).toISOString();
        })
        this.fetchExperts();
        this.fetchCorporations();
          setTimeout(() => {
            // self.corpIds = self.playlist.csvCorporationId.split(',')
            this.event.csvExpertsIds = this.event.csvExpertsIds.split(',')
          }, 1500)
    },
    data () {
        let dateTime = new Date();
        return {
            newImage: [],
            today: dateTime.toISOString(),
            startDate: dateTime.toISOString(),
            endDate: new Date(dateTime.setHours(dateTime.getHours() + 1)).toISOString(),
            event: this.selectedEvent || {},
            rules: {
                title: {required : true, min: 5},
                description: {required : true, min : 15},
                longDescription: {required : true, min : 15},
                duration: {required : true},
                img_url: {required: true},
                tags: {required: true},
                expertId: {required: true},
                authBanner: {required: true},
                unAuthBanner: {required: true},
//                jw_stream_title: {required: true},
//                jw_rtmp_url: {required: true},
                chatroll_event_name: {required: true},
                type: {required: true},
                status: {required: true},
                isPrivate: {required: true}
            },
            message: {
                error: false,
                text: ''
            },
            experts: [],
            corporations: [],
            type: [{name:'Select Type'}, {id:1, name:'Live Event'}, {id:2, name:'Talk Event'}, {id:3, name:'Corporation Self-Hosted Event'}],
            status: [{name:'Select Status'}, {id:1, name:'Active'}, {id:0, name:'Inactive'}],
          eventType: [{name:'Select'}, {id:1, name:'Private'}, {id:0, name:'Public'}]
        }
    },
    methods: {
      fetchCorporations () {
        this.$store.dispatch('FETCH_CORPORATIONS')
          .then((res) => {
            res.unshift({name: "Select an option"});
            this.corporations = res;
            console.log("this.corporations : ", this.corporations);
          })
          .catch(err => {
            console.log("API error : ", err);
          }),
          (err) => {
            console.log("err : ", err);
          }
      },
        updateEvent () {
            console.log("typeof this.startDate : ", typeof this.startDate);
            console.log("this.startDate : ", this.startDate);
            console.log("this.endDate : ", this.endDate);
            let startDate = new Date(this.startDate).getTime();
            let endDate = new Date(this.endDate).getTime();
            if(endDate < startDate){
                this.$swal(
                        'Error!',
                        'Event End Date must be greater then start Date.',
                        'error'
                ).then(() => {
                            return false
                        })
            }
            else if(!this.event.img_url){
                this.$swal(
                        'Error!',
                        'Event Image is not selected',
                        'error'
                ).then(() => {
                            return false
                        })
            }
            else{
                this.$validator.validateAll().then((result) => {
                    if(result){

                        this.event.start_date =  moment(startDate).format('MM/DD/YYYY H:mm:ss');
                        this.event.end_date =  moment(endDate).format('MM/DD/YYYY H:mm:ss');
                       this.event.csvExpertsIds = this.event.csvExpertsIds.toString()
                        let updateEvent = () =>{
//                            this.$store.dispatch('UPDATE_EVENT', this.event)
                            this.$store.dispatch('UPDATE_EVENT', {event: this.event, file: this.newImage})
                                    .then((res) => {
                                        console.log("UPDATE_EVENT res : ", res);
                                        this.showPopup('Success!', 'Event is successfully updated', 'success', ()=>this.$router.push('/admin/events'))

                                    })
                                    .catch(err => {
                                        this.showPopup('Error!', 'some thing happen wrong', 'error')
                                        console.log("UPDATE_EVENT API error : ", err);
                                    })
                        }

                        /*if(this.newImage.length){
                            this.$store.dispatch('TOGGLE_LOADING', true);
                            imageHelpers.upload({
                                        data: this.event.img_url,
                                        file: this.newImage[0],
                                    },
                                    (err, res) => {
                                        console.log("imageHelpers.upload err : ", err);
                                        console.log("imageHelpers.upload res : ", res);
                                        if(res){
                                            console.log("this.newImage : ", this.newImage)
                                            this.event.img_url = res.Location;*/
                                            updateEvent();
                                        /*}
                                    });
                        }
                        else updateEvent();*/
                    }
                })
            }
            console.log("this.event : ", this.event);
        },
        fetchExperts () {
            this.$store.dispatch('FETCH_EXPERTS')
                    .then((res) => {
                        res.unshift({name: "Select an option"});
                        this.experts = res;
                        console.log("this.experts : ", this.experts);
                    })
                    .catch(err => {
                        console.log("API error : ", err);
                    }),
                    (err) => {
                        console.log("err : ", err);
                    }
        },
        updateValue(data){
//            this.event.img_url = data;
            this.event.img_url = data.path;
            this.newImage = data.value;
            console.log("updateValue data : ", data);
        },
        showPopup(title, msg, popupType, cb){
            this.$swal( title, msg, popupType
            ).then(res => {
                        cb && cb();
                        return res
                    })
        }
    },
    computed: {...mapGetters([
        'events', `getEvent${11}`, 'selectedEvent', 'selectedExpert']) }
    }
</script>

<style>
    .form-control{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Events/EditEvent.vue